<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="User Mobile" prop="mobile">
                <a-input v-model="queryParam.mobile" placeholder="Please enter user mobile" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="Order No." prop="orderNo">
                <a-input v-model="queryParam.orderNo" placeholder="Please enter order number" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="Recharge Amount" prop="rechargeMoney">
                  <a-input v-model="queryParam.rechargeMoney" placeholder="Please enter recharge amount" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="Pay Amount" prop="payMoney">
                  <a-input v-model="queryParam.payMoney" placeholder="Please enter pay amount" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />Search</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />Reset</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="handleExport" v-hasPermi="['golf:rechargeorder:export']">
          <a-icon type="download" />Export
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="payType" slot-scope="text">
          {{ formatPayType(text) }}
        </span>
        <span slot="status" slot-scope="text">
          {{ formatPayStatus(text) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['golf:recharge/order:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['golf:recharge/order:edit']">
            <a-icon type="edit" />Edit
          </a>
          <a-divider type="vertical" v-hasPermi="['golf:recharge/order:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['golf:recharge/order:remove']">
            <a-icon type="delete" />Delete
          </a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `Total ${total} items`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageRechargeOrder, delRechargeOrder } from '@/api/golf/rechargeOrder'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'RechargeOrder',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        menuId: null,
        mobile: null,
        orderNo: null,
        rechargeMoney: null,
        payMoney: null,
        payType: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'User Mobile',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Order No.',
          dataIndex: 'orderNo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Recharge Amount',
          dataIndex: 'rechargeMoney',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Pay Amount',
          dataIndex: 'payMoney',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Payment Method',
          dataIndex: 'payType',
          scopedSlots: { customRender: 'payType' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Payment Status',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    formatPayType (val) {
      const map = {
        0: 'VISA',
        1: 'Mastercard',
        2: 'ApplePay',
        3: 'GooglePay'
      }
      if (val === null || val === undefined || val === '') {
        return '—'
      }
      const n = Number(val)
      if (!Number.isFinite(n) || !Object.prototype.hasOwnProperty.call(map, n)) {
        return '—'
      }
      return map[n]
    },
    formatPayStatus (val) {
      const map = {
        0: 'Unpaid',
        1: 'Paid',
        2: 'Failed'
      }
      if (val === null || val === undefined || val === '') {
        return '—'
      }
      const n = Number(val)
      if (!Number.isFinite(n) || !Object.prototype.hasOwnProperty.call(map, n)) {
        return '—'
      }
      return map[n]
    },
    getList () {
      this.loading = true
      pageRechargeOrder(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        menuId: undefined,
        mobile: undefined,
        orderNo: undefined,
        rechargeMoney: undefined,
        payMoney: undefined,
        payType: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: 'Confirm deletion of selected data?',
        content: 'Selected IDs: ' + ids,
        onOk () {
          const data = []
          that.ids.map(id => data.push({ id: id }))
          return delRechargeOrder(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                'Deleted successfully',
                3
              )
          })
        },
        onCancel () {
          that.ids = []
        }
      })
    },
    handleExport () {
      var that = this
      this.$confirm({
        title: 'Confirm export?',
        content: 'This will export all data under current filters, not just selected rows.',
        onOk () {
          const { pageNum, pageSize, ...exportParam } = that.queryParam
          that.download('golf/golf-recharge-order/export', exportParam, `recharge_order_${new Date().getTime()}.xls`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
